import React, { useEffect } from "react";
import FooterPageLayout from "src/layouts/footer-page";

export default function Privacy() {
    useEffect(() => {
        const script = document.createElement("script");
        script.src = "https://app.termly.io/embed-policy.min.js";
        script.async = true;
        document.body.appendChild(script);
    }, []);

    return (
        <FooterPageLayout title="Privacy Policy">
            <style>{`
                footer {
          position: relative;
          width: 100%;
          padding: 0;
          margin:0;
          z-index: 1;
          background:#fff;
          border:none;
        }
        footer div {
          display: flex;
          justify-content: center;
          align-items: center;
          flex-wrap:wrap;
          color: #e3dedb;
          font-size: 12px;
          margin:0 auto;
          padding: 10px 0;
          list-style:none;
        }
        footer div a {
          margin: 0;
        }
          footer div a:hover {
          text-decoration: none;
          color: #9b928b;
        }
        footer div a:after {
          content: '|';
          padding: 0 8px;
        }

        footer div a:last-child:after {
          content: none;
          padding: 0;
        }
            `}</style>
            <div className="privacy-container">
                <div
                    className="privacy-embed"
                    name="termly-embed"
                    data-id="24b80033-9965-4163-83ae-9b745d07fa39"
                    data-type="iframe"
                ></div>
            </div>
        </FooterPageLayout>
    );
}
